const mainHeader = document.getElementById('main-header'); // Ensure you select the header element
const medicineDetailsView = document.querySelector('.medicine-details-page'); // Scrolling behaviour on medicine details sidebar

let previousScrollPosition = window.scrollY;
let isAnchorScrolling = false;

window.addEventListener('scroll', () => {
  if (isAnchorScrolling) return;

  const currentScrollPosition = window.scrollY;
  const headerHeight = mainHeader.offsetHeight;

  if (currentScrollPosition > headerHeight) {
    if (currentScrollPosition > previousScrollPosition) {
      // Scrolling down
      mainHeader.classList.add('hidden');
      medicineDetailsView?.classList.remove('header-offset-active');
    } else {
      // Scrolling up
      mainHeader.classList.remove('hidden');
      medicineDetailsView?.classList.add('header-offset-active');
    }
  }

  previousScrollPosition = currentScrollPosition;
});

//  Anchor links (sidebar)
  document.querySelectorAll('.menu-list a[href^="#"], .mobile-menu-list a[href^="#"]')
  .forEach(anchor => {
    anchor.addEventListener('click', e => {
      const id = anchor.getAttribute('href');
      if (!id || id === '#') return;

      const target = document.querySelector(id);
      if (!target) return;

      e.preventDefault();

      const currentY = window.scrollY;
      const targetY = target.getBoundingClientRect().top + currentY;
      const isScrollingUp = targetY < currentY;

      // Show navbar when scrolling up
      if (isScrollingUp) {
        isAnchorScrolling = true;
        mainHeader.classList.remove('hidden');
        medicineDetailsView?.classList.add('header-offset-active');
      }

      // Perform animation
      requestAnimationFrame(() => {
        const y =
          targetY -
          (isScrollingUp ? mainHeader.offsetHeight : 0);

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });

        if (!isScrollingUp) {
          isAnchorScrolling = false;
        }
      });
    });
  });